import DataTable from '../../../../../components/DataTable'
import { nameEntity, nameSource } from '../domain/info'
import { headers } from '../domain/headers'
import { breadcrumbList } from '../domain/breadcrumb'
import { toolsList } from '../domain/tools'
import Container from '../../../../../components/Container'

const StudentList = (): JSX.Element => (
  <Container pageTitle="Listagem" breadcrumb={breadcrumbList} tools={toolsList}>
    <DataTable
      source={nameSource}
      entity={nameEntity}
      format={{ orderBy: 'name' }}
      headers={headers}
      actions={[
        {
          name: 'Visualizar',
          title: 'Visualizar',
          spanIcon: 'fa fa-search',
          linkTo: order => `/commercial/students/view/${order.id}`,
          style: { margin: '0 5px' }
        },
        {
          name: 'Atualizar',
          title: 'Atualizar',
          spanIcon: 'fa fa-edit',
          linkTo: order => `/commercial/students/update/${order.id}`,
          style: { margin: '0 5px' }
        }
      ]}
    />
  </Container>
)

export default StudentList
